import {
  jb_text_field_css_default
} from "./chunk.43BTYACE.js";
import {
  Rt
} from "./chunk.DS2KVX5X.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  applyStyles
} from "./chunk.NKAUZW5M.js";
import {
  D,
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  FormElement
} from "./chunk.YSL2HSIS.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  n,
  r as r2
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-text-field/jb-text-field.ts
var JbTextField = class extends Initiable(FormElement(r)) {
  constructor() {
    super(...arguments);
    this._currentLength = 0;
    this._showEmailError = false;
  }
  connectedCallback() {
    super.connectedCallback();
    applyStyles(this, jb_text_field_css_default);
  }
  createRenderRoot() {
    return this;
  }
  validate() {
    let valid = super.validate();
    if (valid && this.type === "email") {
      this._showEmailError = this.value === "" && this.requiredText === "" ? false : !this.validateEmail();
      valid = !this._showEmailError;
    }
    return valid;
  }
  validateEmail() {
    const re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    return re.test(String(this.value).toLowerCase());
  }
  _handleInputChange(e) {
    this.value = e.target.value;
    this._currentLength = this.value.length;
    this.validate();
  }
  render() {
    return ke`
      <div class=${Rt({ white: !!this.isWhite, hidden: this.type === "hidden" })}>
        <input
          class=${Rt({
      optional: this.requiredText === "" || !this.requiredText,
      error: this.showError || this._showEmailError || !!this.errorText
    })}
          ?disabled=${this.disabled}
          .name=${this.name}
          ?required=${!!this.requiredText}
          .value=${typeof this.value === "string" ? this.value : ""}
          .type=${this.type}
          .id=${this.name}
          placeholder="${this.placeholder}${this.requiredText ? "*" : ""}"
          .autocomplete=${this.autocomplete ?? "on"}
          @change=${this._handleInputChange}
          .maxLength=${this.maxLength ?? D}
          @input=${(evt) => {
      if (!this.maxLength) return;
      this._currentLength = evt.currentTarget.value.length;
    }}
          aria-label=${this.label}
          aria-errormessage=${this.showError || this.errorText || this._showEmailError ? `${this.name}_error` : D}
          aria-invalid="${this.showError || this.errorText || this._showEmailError ? "true" : "false"}"
        />
        ${this.maxLength ? ke`<div class="counter">
              <span>${this.maxLengthText ?? D}</span><span>${this._currentLength} / ${this.maxLength}</span>
            </div>` : D}
        <label
          for=${this.name}
          id="${this.name}_label"
          >${this.label}${this.requiredText ? "*" : ""}</label
        >
        <div
          id="${this.name}_error"
          aria-live="polite"
        >
          ${this.showError || this.errorText || this._showEmailError ? ke`<p>
                ${this.showError ? ke`<span>${this.requiredText}</span>` : D}
                ${this.errorText ? ke`<span>${this.errorText}</span>` : D}
                ${!this.showError && this._showEmailError ? ke`<span>${this.emailErrorText}</span>` : D}
              </p>` : D}
        </div>
      </div>
    `;
  }
};
JbTextField.styles = [reset_css_default, jb_text_field_css_default];
__decorateClass([
  n()
], JbTextField.prototype, "autocomplete", 2);
__decorateClass([
  n()
], JbTextField.prototype, "emailErrorText", 2);
__decorateClass([
  n({ type: Boolean })
], JbTextField.prototype, "isWhite", 2);
__decorateClass([
  n({ type: Number })
], JbTextField.prototype, "maxLength", 2);
__decorateClass([
  n()
], JbTextField.prototype, "maxLengthText", 2);
__decorateClass([
  n()
], JbTextField.prototype, "placeholder", 2);
__decorateClass([
  n()
], JbTextField.prototype, "type", 2);
__decorateClass([
  r2()
], JbTextField.prototype, "_currentLength", 2);
__decorateClass([
  r2()
], JbTextField.prototype, "_showEmailError", 2);
JbTextField = __decorateClass([
  customElement("jb-text-field")
], JbTextField);

export {
  JbTextField
};
